<label class="label" [attr.for]="id">
  <typography look="formLabel">{{ props.label }}</typography>
  <ng-container *ngIf="props.required && props.hideRequiredMarker !== true">*</ng-container>
</label>

<ng-template #fieldComponent></ng-template>
